<template>
  <div>
    <nav-bar />
    <div class="filter-button-group mb-2">
        <toggle-button-group
        :buttons="filterOptions" 
        :activeButton="selectedFilter" 
        :handleClick="handleFilterButtonClick" 
      />
    </div>
    <div>
      <div class="kne-title p-10">
        <h3>{{ $t('WallFile.title') }}</h3>
      </div>

      <div class="df">
        <h4 style="padding-left: 20px; margin-top: 1rem">Selected group : {{ selectedGroup && selectedGroup.name ? selectedGroup.name : '-' }}</h4>
        <div class="button-group">
          <button id="addOrder" class="btn btn-kne-orange" v-if="isAdmin" @click="showAddModal = true">
            {{ $t('WallFile.add_wallfile') }}
          </button>
          <button id="addOrder" class="btn btn-kne-orange" v-if="isAdmin" @click="showValidateZonesModal = true">
            {{ $t('WallFile.validate_zones') }}
          </button>
        </div>
      </div>

      <wall-file-modal v-if="showAddModal" @closeModal="closeModal" class="waf-modal"></wall-file-modal>
      <wall-file-modal v-if="showUpdateModal" @closeModal="closeModal" :wallFile="wallFile" :isAdmin="isAdmin" class="waf-modal"></wall-file-modal>

      <validate-zones-modal v-if="showValidateZonesModal" @closeModal="closeValidateModal"
        :arrOfWallfile="sortedWallFiles"></validate-zones-modal>

        <div class="main">
          <div class="list-div bg-darkgrey navbar-inverse side-box-shadow" >
            <ul class="nav flex-column">
              <li v-for="item in groups" :key="item.id" class="nav-item" :class="{'current': selectedGroup.name === item.name}">
                <a class="nav-link navbar-text pull-left d-b"  @click="handleItemClick(item)">{{ item.name }}
                </a>
              </li>
            </ul>
          </div>
          <div class="card-div">
        <div class="cards-div">
            <div class="wall-file-card card" v-for="(item, index) in wallFiles" :key="index" v-if="wallFileIds.includes(item.id)">
              <h4 class="kne-title" :disabled="isLoading" @click="handleNavigateToZone(item)">
                <div class="df">
                  <div class="wallfile-name">
                    {{ item.name }}
                  </div>
                </div>
              </h4>
              <div class="info-card">
                <div style="font-weight: 600;">Total Orders : <span> {{ item.totalOrders || '0' }} </span> </div>
                <div>Processing Orders : <span> {{ item.totalProcessingOrders || '0' }} </span> </div>
                <div>Warning Orders : <span> {{ item.totalWarningOrders || '0' }} </span> </div>
                <div>Late Orders : <span> {{ item.totalLateOrders || '0' }} </span> </div>
                <div class="btns">
                  <button class="btn-del m-l-a" @click="editWallFile(item)" v-if="isAdmin">
                    <i class="fa fa-pencil" aria-hidden="true" />
                  </button>
                  <button class="btn-del m-l-a" @click="editWallFile(item)" v-if="!isAdmin">
                    <i class="fa fa-eye" aria-hidden="true" />
                  </button>
                  <button class="btn-del" @click="deleteWallFile(item.id)" v-if="isAdmin">
                    <i class="fa fa-trash" aria-hidden="true" />
                  </button>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import { db } from '../../firebase'
import RegularInput from '../module/basic-components/regularInput'
import HoverToolTip from '../module/basic-components/hoverToolTip.vue'
import SidebarToggleButton from '../module/interface-components/sidebarToggleButton.vue'
import WallFileModal from '../module/special-components/Modal-templates/NewWallFile-modal.vue'
import ValidateZonesModal from '../module/special-components/Modal-templates/ValidateZones-modal.vue'
import ToggleButtonGroup from '../module/special-components/Other-components/ToggleButtonGroup.vue'
import Draggable from 'vuedraggable'
import RegularSelect from '../module/basic-components/regularSelect.vue'
import * as turf from '@turf/turf'
import { isRegularOrder } from '@/inventory/inventorySelectors'

export default {
  name: 'Settings',
  components: {
    RegularInput,
    HoverToolTip,
    SidebarToggleButton,
    WallFileModal,
    ValidateZonesModal,
    Draggable,
    RegularSelect,
    ToggleButtonGroup
  },

  data () {
    return {
      wallFiles: [],
      showAddModal: false,
      showValidateZonesModal: false,
      showUpdateModal: false,
      wallFile: {},
      list: 'Main',
      isLoading: true,
      processing: [],
      orders: [],
      bookmarks: [],
      zones: [],
      groups: [],
      selectedGroup: {},
      selectedWallFile: {},
      groupIdToSelect: '',
      wallFileIds: [],
      selectedFilter: 'wallfile',
      filterOptions: [
        { label: this.$t('NavBar.wallfile'), value: 'wallfile', route: '/WallFile' },
        { label: this.$t('NavBar.drivers'), value: 'driver', route: '/Drivers' },
        { label: this.$t('NavBar.clients'), value: 'client', route: '/Clients' }
      ],
      groupsListener: null
    }
  },
  async created () {
    await this.getZones()
    this.getWallFiles()

    const groupId = this.$route.query.groupId
    if (groupId) {
      this.groupIdToSelect = groupId
    }

    this.getGroups()
  },
   mounted () {
  },
  beforeDestroy () {
    if (this.groupsListener) {
      db.ref('database/groups/transporter').child(this.companyUID).child('group').off('value', this.groupsListener)
    }
  },
  methods: {
    async getZones () {
      // Use zones from store
      if (!this.$store.state.zonesLoaded) {
        await this.$store.dispatch('subscribeToZones')
      }
      this.zones = this.$store.state.zones
      return Promise.resolve()
    },
    sortData (arr) {
      return arr.sort((a, b) => {
        const aIndex = a.index || Number.MAX_VALUE
        const bIndex = b.index || Number.MAX_VALUE
        return bIndex - aIndex
      })
    },
    handleNavigateToZone (item) {
      this.navigateToZone(item)
    },
    handleFilterButtonClick (buttonName) {
      this.selectedFilter = buttonName

      const selectedOption = this.filterOptions.find(option => option.value === buttonName)
      if (selectedOption && selectedOption.route) {
        this.$router.push(selectedOption.route)
      }
    },
    async getWallFiles () {
      await db.ref('database/wallfiles/transporter').child(this.companyUID).child('wallfile').once('value', (snapshot) => {
        const wallFilesData = snapshot.val() || {}
        this.wallFiles = Object.entries(wallFilesData).map(([id, zoneData]) => {
          return {
              id,
            ...zoneData,
            index: Number.MAX_VALUE,
            priority: Number.MAX_VALUE,
            totalOrders: 0,
            totalProcessingOrders: 0,
            totalWarningOrders: 0,
            totalLateOrders: 0
          }
        })
        this.wallFiles.forEach(wallfile => {
          wallfile.actualPickZones = wallfile.customPickZones ? [...wallfile.customPickZones] : []
          wallfile.actualDropZones = wallfile.customDropZones ? [...wallfile.customDropZones] : []
          if (wallfile.pickPolygon) {
            wallfile.pickZones = wallfile.customPickZones || []
            const arr = this.isZoneIntersecting(wallfile.pickPolygon, this.zones)
            wallfile.pickZones.push('')
            wallfile.pickZones.push(...arr)
          }
          if (wallfile.dropPolygon) {
            wallfile.dropZones = wallfile.customDropZones || []
            const arr = this.isZoneIntersecting(wallfile.dropPolygon, this.zones)
            wallfile.dropZones.push('')
            wallfile.dropZones.push(...arr)
          }
          const pickZonesByName = []
          const dropZonesByName = []
          if (wallfile.pickZones && wallfile.pickZones.length) {
            wallfile.pickZones.forEach(pickZone => {
              const item = this.zones.filter(zone => zone.id === pickZone)
              if (item.length && !pickZonesByName.includes(item[0].zoneName)) {
                pickZonesByName.push(item[0].zoneName)
              }
            })
            wallfile.pickZonesByName = pickZonesByName
          } else {
            pickZonesByName.push('All')
          }
          if (wallfile.dropZones && wallfile.dropZones.length) {
            wallfile.dropZones.forEach(dropZone => {
              const item = this.zones.filter(zone => zone.id === dropZone)
              if (item.length && !dropZonesByName.includes(item[0].zoneName)) {
                dropZonesByName.push(item[0].zoneName)
              }
            })
            wallfile.dropZonesByName = dropZonesByName
          } else {
            dropZonesByName.push('All')
          }
        })
        this.isLoading = true
        this.getOrders()
      })
      .catch(error => {
        confirm('Unable to fetch wall files')
        console.error('Error fetching wall files:', error)
      })
    },
    async getGroups () {
      this.groupsListener = await db.ref('database/groups/transporter').child(this.companyUID).child('group').on('value', (snapshot) => {
        if (!snapshot.exists()) {
          this.groups = []
          return
        }
        this.groups = Object.entries(snapshot.val()).map(([id, zoneData]) => ({
              id,
              ...zoneData
        }))

        // Select the group from URL if available
        if (this.groupIdToSelect && this.groups.length > 0) {
          const groupToSelect = this.groups.find(g => g.id === this.groupIdToSelect)
          if (groupToSelect) {
            this.handleItemClick(groupToSelect)
          }
          this.groupIdToSelect = null
        } else {
            const groupToSelect = this.groups[0] || null
            this.handleItemClick(groupToSelect)
        }
      })
    },
    handleItemClick (item) {
      this.wallFileIds = []
      let selectedGroups = this.groups.filter(g => g.id === item.id)
      if (!selectedGroups.length) return
      this.selectedGroup = selectedGroups[0]

      // Update URL with the selected group ID as a query parameter
      this.$router.push({
        query: { groupId: item.id }
      })

      Object.keys(this.selectedGroup.wallFiles).forEach(key => {
        this.wallFileIds.push(key)
      })
      // Rest of the existing code
      this.wallFiles.forEach(wf => {
        if (this.wallFileIds.includes(wf.id)) {
          wf.priority = this.selectedGroup.wallFiles[wf.id]
          wf.index = this.selectedGroup.wallFiles[wf.id]
        } else {
          wf.priority = Number.MAX_VALUE
          wf.index = Number.MAX_VALUE
        }
      })
      this.wallFiles = this.wallFiles.sort((a, b) => a.priority - b.priority)
      this.$forceUpdate()
    },
    lastHistorySync (obj, key) {
      // Check if obj is null or undefined
      if (!obj || typeof obj !== 'object') {
        return null
      }

      const lastKey = Object.keys(obj)
        .sort((a, b) => {
          const numA = parseInt(a.split('-')[1], 10)
          const numB = parseInt(b.split('-')[1], 10)
          return numA - numB
        })
        .pop()
      if (lastKey && obj[lastKey] && obj[lastKey][key]) {
        return obj[lastKey][key]
      } else {
        return null
      }
    },
    getOrders () {
      // Use store deliveries instead of binding
      if (!this.$store.state.deliveriesLoaded) {
        this.$store.dispatch('subscribeToDeliveries')
      }
      this.processOrders()
    },
    processOrders () {
      const allDeliveries = this.$store.state.deliveries.filter(isRegularOrder)
      this.processing = allDeliveries.filter(order => ((order.status !== 'Drop' ||
                    (order.status === 'Drop' && order.historySync && order.receiverAddress === this.lastHistorySync(order.historySync, 'receiverAddress'))
                  ) && (
        order.status !== 'Pick' || (order.status === 'Pick' && order.historySync && order.transmitterAddress === this.lastHistorySync(order.historySync, 'transmitterAddress'))
      )))
      // Reset all wallfile counts before processing
      this.wallFiles.forEach(wallfile => {
        wallfile.totalOrders = 0
        wallfile.totalProcessingOrders = 0
        wallfile.totalWarningOrders = 0
        wallfile.totalLateOrders = 0
        wallfile.orders = []
      })

      this.processing.forEach(order => {
        // Skip if order doesn't have required coordinates
        if (!order.transmitterLat || !order.transmitterLong || !order.receiverLat || !order.receiverLong) {
          return
        }

        const pickPoint = turf.point([parseFloat(order.transmitterLong), parseFloat(order.transmitterLat)])
        const dropPoint = turf.point([parseFloat(order.receiverLong), parseFloat(order.receiverLat)])

        this.wallFiles.forEach(wallfile => {
          let isInPickZone = false
          let isInDropZone = false

          // Check if order pickup point is within any of the wallfile's pick zones
          if (wallfile.actualPickZones && wallfile.actualPickZones.length > 0) {
            isInPickZone = wallfile.actualPickZones.some(zoneData => {
              if (!zoneData.coordinates || zoneData.coordinates.length < 3) return false // Skip invalid zones

              // Create a closed polygon from coordinates
              const polygonCoords = [...zoneData.coordinates]
              if (!this.arePointsEqual(polygonCoords[0], polygonCoords[polygonCoords.length - 1])) {
                polygonCoords.push(polygonCoords[0]) // Close the polygon
              }

              try {
                const polygon = turf.polygon([polygonCoords])
                return turf.booleanPointInPolygon(pickPoint, polygon)
              } catch (error) {
                console.error('Error checking pickup point in polygon:', error)
                return false
              }
            })
          }

          // Check if order drop point is within any of the wallfile's drop zones
          if (wallfile.actualDropZones && wallfile.actualDropZones.length > 0) {
            isInDropZone = wallfile.actualDropZones.some(zoneData => {
              if (!zoneData.coordinates || zoneData.coordinates.length < 3) return false // Skip invalid zones

              // Create a closed polygon from coordinates
              const polygonCoords = [...zoneData.coordinates]
              if (!this.arePointsEqual(polygonCoords[0], polygonCoords[polygonCoords.length - 1])) {
                polygonCoords.push(polygonCoords[0]) // Close the polygon
              }

              try {
                const polygon = turf.polygon([polygonCoords])
                return turf.booleanPointInPolygon(dropPoint, polygon)
              } catch (error) {
                console.error('Error checking drop point in polygon:', error)
                return false
              }
            })
          }

          // If order matches both pick and drop zones, increment counters
          if (isInPickZone && isInDropZone && order.status) {
            wallfile.totalOrders += 1
            wallfile.orders.push(order)

            if (order.status === 'Processing') {
              wallfile.totalProcessingOrders += 1
            }

            if (order.warningTime && order.lateTime) {
              if (this.isLateOrder(order)) {
                wallfile.totalLateOrders += 1
              } else if (this.isWarningOrder(order)) {
                wallfile.totalWarningOrders += 1
              }
            }
          }
        })
      })

      this.isLoading = false
      this.$forceUpdate()
    },

    isLateOrder (order) {
      const statuses = [ 'Processing', 'Reject', 'Attente', 'Transit' ]

      if (!order.status) return false

      if (!order.lateTime) return false

      const currentDate = Date.now()

      return (statuses.includes(order.status) && currentDate >= order.lateTime)
    },
    isWarningOrder (order) {
      const statuses = [ 'Processing', 'Reject', 'Attente', 'Transit' ]

      if (!order.status) return false

      if (!order.warningTime) return false

      const currentDate = Date.now()

      return (statuses.includes(order.status) && currentDate >= order.warningTime)
    },

    arePointsEqual (point1, point2) {
      return point1[0] === point2[0] && point1[1] === point2[1]
    },
    checkPolygonIntersection (polygon1, polygon2) {
      const feature1 = turf.polygon(polygon1, {
        crs: {
          type: 'name',
          properties: {
            name: 'WGS84'
          }
        }
      })
      const feature2 = turf.polygon(polygon2, {
        crs: {
          type: 'name',
          properties: {
            name: 'WGS84'
          }
        }
      })
      const intersects = turf.booleanIntersects(feature1, feature2)
      return intersects
    },
    mapPolygons (polygon) {
      let arr = [[...polygon]]
      arr[0].push(arr[0][0])
      return this.normalizePolygon(arr)
    },
    normalizePolygon (polygon) {
      const normalized = polygon.map(ring => {
        let prevLng = ring[0][0]
        return ring.map(coord => {
          let [lng, lat] = coord

          // Adjust longitude based on previous point
          while (lng - prevLng > 180) lng -= 360
          while (lng - prevLng < -180) lng += 360

          prevLng = lng
          return [lng, lat]
        })
      })

      // Ensure the polygon is closed
      const firstRing = normalized[0]
      if (firstRing[0][0] !== firstRing[firstRing.length - 1][0] ||
          firstRing[0][1] !== firstRing[firstRing.length - 1][1]) {
        firstRing.push(firstRing[0])
      }

      return normalized
    },
    isZoneIntersecting (newZoneCoordinates, zones) {
      let intersecting = []
      zones.forEach((zone) => {
        if (this.zone && this.zone.id === zone.id) {
          return
        }
        if (this.checkPolygonIntersection(this.mapPolygons(newZoneCoordinates), this.mapPolygons(zone.coordinates))) {
          intersecting.push(zone.id)
        }
      })
      return intersecting
    },
    deleteWallFile (wallFile) {
      if (!confirm('Please confirm to delete the wallfile')) return

      db.ref('database/wallfiles/transporter').child(this.companyUID).child('wallfile').child(wallFile).remove()
        .then(() => {
          console.log('Wallfile deleted')
          this.closeModal()
        })
        .catch(error => {
          confirm('Error deleting wall file')
          console.error('Error deleting wallfile from firebase:', error)
        })
    },
    editWallFile (wallFile) {
      this.showUpdateModal = true
      this.wallFile = wallFile
    },
    onValueChange (event) {
      this.list = event.target.value
    },
    navigateToZone (wallfile) {
    if (this.isLoading) return
    if (!wallfile || !wallfile.totalOrders) {
      confirm('No orders found for the wall file')
      return
    }
    this.$router.push({
      name: 'Zone',
      query: {
        wallFileId: wallfile.id
      }
    })
    // this.$router.push({
    //   name: 'Zone',
    //   params: {
    //     wallFile: true,
    //     orders: wallfile.orders,
    //     wallFileName: wallfile.name
    //   }
    // })
  },
    async closeModal () {
      this.showAddModal = false
      this.showUpdateModal = false
      await this.getWallFiles()
      this.handleItemClick(this.selectedGroup)
    },
    async closeValidateModal () {
      this.showValidateZonesModal = false
      await this.getGroups()
      await this.getWallFiles()
      this.handleItemClick(this.selectedGroup)
    }
  },
  computed: {
    companyUID () {
      return this.$store.state.authorization.company
    },
    uid () {
      return this.$store.state.user.uid
    },
    sortedWallFiles () {
      return this.sortData(this.wallFiles.map(wallFile => wallFile))
    },
    isAdmin () {
      return this.$store.state.authorization.role === 'Admin'
    },
    storeDeliveries () {
      return this.$store.state.deliveries
    }
  },
  watch: {
    storeDeliveries: {
      handler () {
        if (this.wallFiles.length > 0) {
          this.processOrders()
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.cards-div {
  height: fit-content;
  flex: 2;
  display: flex;
  align-items: flex-start;
  padding: 20px;
  padding-right: 0%;
  gap: 13px;
  flex-wrap: wrap;
}
.nav-link {
  cursor: pointer;
}
.kne-title {
  margin-bottom: 0;
}

.wall-file-card {
  height: 220px;
  width: 19%;
  min-width: 300px;
}

.info-card {
  padding: 15px;
}

.wallfile-name {
  width: 80%;
}

.btns {
  display: flex;
}

.btn-del {
  color: black;
  width: 35px;
  background: none;
  border: none !important;
}

.btn-del:active, .btn-del:focus {
  outline: none;
  border: none !important;
}

#addOrder {
  margin-right: 10px;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.cards-div .kne-title div {
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.df {
  display: flex;
  flex-wrap:wrap;
}

.m-l-a {
    margin-left: auto;
}

.p-10 {
  padding: 10px;
}

.card-div {
  flex: 2;
  height: calc(100vh - 170px);
  overflow-y: auto;
  scrollbar-width: thin;
}

.current {
  border-left: 3px solid #f7941e;
}

.main {
  display: flex;
  width: 100%;
}

.list-div {
  height: calc(100vh - 170px);
  overflow-y: auto;
  padding-top: 20px;
  padding-bottom: 20px;
  scrollbar-width: thin;
  width: 200px;
}

.d-b {
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
@media (max-width: 1200px) {
  .wall-file-card {
    width: calc(33.33% - 16px);
  }
}

@media (max-width: 900px) {
  .wall-file-card {
    width: calc(50% - 16px);
  }

  .list-div {
    width: 180px;
  }
}

@media (max-width: 700px) {
  .main {
    flex-direction: column;
  }

  .list-div {
    width: 100%;
    height: auto;
    border-bottom: 2px solid #ddd;
    padding: 10px 0;
  }

  .card-div {
    width: 100%;
    height: auto;
  }

  .wall-file-card {
    width: 100%;
    min-width: unset;
    margin-inline: 8px;
  }
}
@media (min-width: 450px) {
    .button-group{
      margin-left:auto;
    }

  }
@media (max-width: 450px) {
  .wall-file-card {
    width: 100%;
  }
  .cards-div {
    width: 100%;
  }
  .select {
    width: 100% !important;
    margin-right: 20px;
  }
  .button-group {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  #addOrder {
    width: 100%;
    margin: 5px 0;
  }
}

</style>
